import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { BtnPrimary, BtnAlternative } from '../buttons/Btn';
import VerificationInput from 'react-verification-input';
import CountDown from '../../../Hooks/CountDown';
import { gql, useMutation } from '@apollo/client';
import { useAuth } from '../../../Context/AuthContext';
import Cookies from 'js-cookie';

const CODE = gql`
	mutation SendCode($username: String) {
		sendCode(username: $username) {
			success
			errors
		}
	}
`;

const REGISTER = gql`
	mutation Register(
		$username: String!
		$code: String!
		$password1: String!
		$password2: String!
		$email: String
	) {
		register(
			username: $username
			code: $code
			password1: $password1
			password2: $password2
			email: $email
		) {
			success
			errors
			refreshToken
			token
		}
	}
`;

const REFRESH = gql`
	mutation refreshToken($refreshToken: String!) {
		refreshToken(refreshToken: $refreshToken) {
			success
			errors
			payload
			token
			refreshToken
		}
	}
`;

function SignIn(props) {
	const [sendCode, setSendCode] = useState();
	const [timeOut, setTimeOut] = useState(false);

	const [showPass, setShowPass] = useState(false);

	const [username, setUsername] = useState();
	const [pass1, setPass1] = useState();
	const [pass2, setPass2] = useState();
	const [code, setCode] = useState();

	const { authRefDispatch, authAccDispatch, authUserDispatch } = useAuth();

	const [sendCodeFunction, { dataCode }] = useMutation(CODE);
	const [registerFunction, { data, error }] = useMutation(REGISTER);
	const [refreshFunction, { dataRef }] = useMutation(REFRESH);

	const {
		register: register1,
		handleSubmit: handleSubmit1,
		control,
		formState: { errors: error1, isSubmitSuccessful },
	} = useForm({
		defaultValues: { phoneSignIn: '' },
		mode: 'onSubmit',
		reValidateMode: 'onSubmit',
	});
	const {
		handleSubmit: handleSubmit2,
		formState: { errors: error2 },
	} = useForm({
		mode: 'onSubmit',
		reValidateMode: 'onSubmit',
	});
	const {
		register: register3,
		handleSubmit: handleSubmit3,
		formState: { errors: error3 },
	} = useForm({
		defaultValues: { passwordSignIn: '', confirmPasswordSignIn: '' },
		mode: 'onSubmit',
		reValidateMode: 'onSubmit',
	});

	const closeModal = (e) => {
		e.stopPropagation();
		props.closeModal();
	};

	const sendCodeHandle = (data) => {
		// data.preventDefault();
		setSendCode(true);
		setTimeOut(false);
		setUsername(data.phoneSignIn);

		sendCodeFunction({
			variables: {
				username: data.phoneSignIn,
			},
		});
	};

	const registerHandle = () => {
		if (username && code) {
			setShowPass(true);
		}
	};

	function registerFinalHandle(data) {
		// setPass1(data.passwordSignIn);
		// setPass2(data.confirmPasswordSignIn);
		props.setLogin(true);
		props.setSignIn(false);
		registerFunction({
			variables: {
				username: username,
				code: code,
				password1: pass1,
				password2: pass2,
			},
		});
	}

	useEffect(() => {
		if (timeOut) {
			setSendCode(false);
		}
	});

	// useEffect(() => {
	//     if (data?.register.success) {
	//         authRefDispatch({
	//             type: "LOGIN",
	//             refToken: data?.register.refreshToken,
	//         });

	//         authAccDispatch({
	//             type: "LOGIN",
	//             accToken: data?.register.token,
	//         });

	//         authUserDispatch({
	//             type: "LOGIN",
	//             username: data?.register.user.username,
	//             id: data?.register.user.id,
	//         });
	//     } else if (
	//         data?.register.error === 401 ||
	//         data?.register.error === 403
	//     ) {
	//         refreshFunction({
	//             variables: { refreshToken: Cookies.get("refresh") },
	//         });
	//     }
	// }, [data, dataRef]);

	return (
		<div>
			<div className={`flex flex-col ${showPass ? 'hidden' : 'block'}`}>
				<h1 className='text-[5rem]'>{dataCode?.errors.nonFieldErrors}</h1>
				<form
					className='flex mb-4'
					onSubmit={handleSubmit1(sendCodeHandle)}
				>
					<input
						type='tel'
						placeholder='شماره تماس'
						className='input text-[1.8rem] border-[1px] w-full max-w-xs rounded-3xl border-[#21212160] p-7 placeholder:text-[1.8rem] leading-[3.2rem] hover:border-light-prim2  focus:border-light-prim2 shadow-2xl'
						{...register1(
							'phoneSignIn',
							{
								required: {
									value: true,
									message: 'شماره خود را وارد کنید',
								},
								minLength: {
									value: 11,
									message: 'شماره خود را صحیح وارد کنید',
								},
								maxLength: {
									value: 11,
									message: 'شماره خود را صحیح وارد کنید',
								},
							},
							{ pattern: '[0-9]+' }
						)}
					/>

					{error1.phoneSignIn && alert(error1.phoneSignIn.message)}

					<BtnPrimary
						text='دریافت کد تایید'
						className='mx-2 py-3 px-9 hover:animate-btnBeat'
						type='submit'
						disabled={timeOut}
					/>
				</form>
				{sendCode ? (
					<div className='flex text-2xl text-purple mb-4 gap-2'>
						<span className='inline-block text-2xl text-purple mb-4'>
							زمان باقی مانده برای دریافت مجدد کد تایید:
						</span>
						<CountDown Min={0} Sec={10} onTimeout={setTimeOut} />
					</div>
				) : null}
				{timeOut ? (
					<span className='inline-block text-2xl text-purple mb-4'>
						مجددا درخواست نمایید
					</span>
				) : null}
				<form
					className='flex flex-col'
					onSubmit={handleSubmit2(registerHandle)}
				>
					<div className=' mb-16'>
						<span className='text-[1.8rem] mb-2 inline-block'>
							کد تایید:
						</span>
						<VerificationInput
							length={6}
							validChars='0-9'
							removeDefaultStyles={true}
							placeholder='_'
							value={code}
							onChange={(e) => {
								setCode(e);
							}}
							classNames={{
								characterSelected: 'character--selected',
							}}
						/>
					</div>
					<BtnPrimary
						text='ثبت نام'
						className='py-8 px-14 hover:animate-btnBeat self-end'
						type='submit'
					/>
				</form>
			</div>
			<div className={`${showPass ? 'block' : 'hidden'} flex flex-col`}>
				<h5 className='text-[2rem] mb-10 self-center'>رمز عبور</h5>
				<form
					onSubmit={handleSubmit3(registerFinalHandle)}
					className='flex flex-col'
				>
					<input
						type='password'
						placeholder='رمز عبور*'
						className='text-[1.8rem] bg-transparent rounded-16 border-2 border-[#C1BFC5] p-6 placeholder:text-[1.8rem] w-[44rem] mb-10'
						{...register3(
							'passwordSignIn',
							{
								onChange: (e) => {
									setPass1(e.target.value);
								},
							},
							{
								required: true,
							}
						)}
						control={control}
						// onChange={(e) => setPass1(e)}
					/>
					<input
						type='password'
						placeholder='رمز عبور*'
						className='text-[1.8rem] bg-transparent rounded-16 border-2 border-[#C1BFC5] p-6 placeholder:text-[1.8rem] w-[44rem] mb-10'
						{...register3(
							'confirmPasswordSignIn',
							{
								onChange: (e) => {
									setPass2(e.target.value);
								},
							},
							{
								required: true,
							}
						)}
						control={control}
					/>
					<BtnPrimary
						text='ثبت نام'
						className='py-8 px-14 hover:animate-btnBeat self-end'
						type='submit'
					/>
				</form>
			</div>
		</div>
	);
}

export default SignIn;

// const CODE = gql`
//     mutation SendCode($username: String) {
//         sendCode(username: $username) {
//             success
//             errors
//         }
//     }
// `;
